module.exports = __webpack_public_path__ + "img/banner_visit.559bf449.png";